"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M0 11.75c0-4.411 3.589-8 8-8s8 3.589 8 8v.5h-1v-.5c0-1.532-.5-2.946-1.338-4.1l-1.571 1.571-.707-.707 1.634-1.634a6.977 6.977 0 0 0-4.473-2.103v2.391h-1V4.773a6.978 6.978 0 0 0-4.501 2.039L4.742 8.51l-.707.707-1.641-1.641A6.95 6.95 0 0 0 1 11.75v.5H0v-.5Zm8.373.4-.897-.443L9.742 7.12l.897.444-2.266 4.586Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M0 17.719c0-6.617 5.383-12 12-12 6.616 0 12 5.383 12 12v.562h-1.125v-.562c0-2.464-.832-4.73-2.218-6.556l-2.418 2.416-.795-.795L19.93 10.3a10.836 10.836 0 0 0-7.297-3.425v3.657h-1.125V6.87a10.835 10.835 0 0 0-7.34 3.326l2.582 2.583-.795.795-2.525-2.525a10.814 10.814 0 0 0-2.304 6.67v.563H0v-.562Zm12.478.342-1.008-.498 3.277-6.636 1.008.498-3.277 6.636Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M0 23.625c0-8.822 7.178-16 16-16s16 7.178 16 16v.75h-1.5v-.75c0-3.285-1.11-6.307-2.958-8.741l-3.223 3.222-1.06-1.06 3.313-3.313a14.448 14.448 0 0 0-9.73-4.566v4.876h-1.5V9.158a14.447 14.447 0 0 0-9.787 4.435l3.444 3.444-1.061 1.06-3.366-3.366A14.419 14.419 0 0 0 1.5 23.625v.75H0v-.75Zm16.638.456-1.345-.663 4.37-8.848 1.344.663-4.37 8.848Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M0 35.531c0-13.233 10.766-24 24-24s24 10.766 24 24v.938h-1.875v-.938a22.01 22.01 0 0 0-4.638-13.53l-4.906 4.906-1.325-1.326 5.019-5.018c-3.82-4.15-9.198-6.84-15.198-7.13v7.411h-1.875v-7.418c-6.01.215-11.414 2.836-15.28 6.93l5.212 5.212-1.325 1.325-5.119-5.117A22.014 22.014 0 0 0 1.875 35.53v.938H0v-.938Zm24.876.427-1.682-.83 6.434-13.027 1.682.83-6.434 13.027Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M0 47.375c0-17.645 14.355-32 32-32s32 14.355 32 32v1.25h-2.5v-1.25a29.344 29.344 0 0 0-6.184-18.04l-6.541 6.541-1.767-1.768 6.692-6.691c-5.093-5.532-12.264-9.12-20.264-9.506v9.881h-2.5v-9.89c-8.013.286-15.219 3.781-20.373 9.239l6.949 6.95-1.767 1.767-6.825-6.824C4.907 34.074 2.5 40.447 2.5 47.375v1.25H0v-1.25Zm33.168.57-2.242-1.108 8.579-17.37 2.242 1.107-8.58 17.37Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconGauge = function IconGauge(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Gauge' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "Gauge"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconGauge.sizes = [16, 24, 32, 48, 64];
IconGauge.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconGauge;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/design-system-icons-react/_cjs/auto/Gauge.js
// module id = 1923
// module chunks = 0